import { LOCAL_STORE_JWT } from "~/utils/main";

export const urlGenre = "/api/tracks/genre";

export const getGenre = (axios, genreId) => axios.get(`${urlGenre}/${genreId}`);
export const getGenrePopular = (axios, genreId) => axios.get(`${urlGenre}/${genreId}/popular`);
export const getGenreTracks = (axios, genreId, page = 1) => axios.get(`${urlGenre}/${genreId}/tracks?page=${page}`);

export const getGenreIsFavorite = (axios, genreId) =>
  axios.post(`${urlGenre}/${genreId}/is_favorite`, { jwt: localStorage.getItem(LOCAL_STORE_JWT) || false });
export const getGenreSetFavorite = (axios, genreId, jwtPayload = false) =>
  axios.post(`${urlGenre}/${genreId}/favorite`, { jwt: jwtPayload ? jwtPayload : localStorage.getItem(LOCAL_STORE_JWT) || false });

export const getGenreList = (axios, terms = "", letter = "") => {
  if (terms !== "") {
    let data = {
      genre_search: terms,
    };
    return axios.post(`${urlGenre}/search?genre_search=${terms}`, data);
  }
  if (letter !== "") {
    return axios.get(`${urlGenre}/starts/${letter}`);
  }
};
export const getGenreStartsWith = (axios, letter) => axios.get(`${urlGenre}/starts/${letter}`);
export const getGenreStartsWithOfficial = (axios, letter) => axios.get(`${urlGenre}/starts/${letter}/official`);
export const getGenreSearchResults = (axios, terms) => axios.post(`${urlGenre}/search?genre_search=${terms}`);

/**
 *
 * http://www.dreamchimney.com/api/tracks/genre/starts/a
 * http://www.dreamchimney.com/api/tracks/genre/starts/z/official
 *
 * http://www.dreamchimney.com/api/tracks/genre/search/certified?genre_search=groove
 */
